import React from 'react';

/**
 * テキスト内のURLを検出してリンクに変換する関数
 * @param text 変換対象のテキスト
 * @returns React.ReactNode[] 変換後のノード配列
 */
export const convertUrlsToLinks = (text: string): React.ReactNode[] => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                    {part}
                </a>
            );
        }
        return part;
    });
};
